
export const k1 = {
  a_0: 'hangzhou',
  a_1: 'cs',
  a_2: 'ali',
  a_3: 'cn',
  a_4: 'oss',
  a_5: 'buc',
  a_6: 'image',
  a_7: 'sayyoo',
  a_8: 'yun',
  a_9: 'ket',
  b_10: 'yss',
  b_11: 'b0Qu',
  b_12: 'IO4',
  b_13: 'TFa',
  b_14: 'LTA',
  c_15: 'LfONr',
  c_16: 'Yxh',
  c_17: 'a6AcB',
  c_18: 'OphS',
  c_19: 'A8KznmaP',
  c_20: 'c24a8'
}



// WEBPACK FOOTER //
// ./src/xhr/services/osssp.js